module.exports = __webpack_public_path__ + "img/prueba_estatica_diesel.6fe628bc.svg";